export default __webpack_public_path__ + "static/media/icon_acma.5d689962.webp";